module.exports = __webpack_public_path__ + "media/images/gallery/4s-ecb5a349e1e3a8c6f44cbaf12fc09392.jpg";